import { FooterContainer, Link } from "./Footer.styles";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(`/${path}`);
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 300);
  };

  const handleEmailClick = () => {
    const recipient = "support@playbox.vip";

    const subject = "Support Request - Playbox.vip";
    const body = `Hello Support Team,

I am experiencing the following issue:

[Please describe your problem here]

Thank you,
[Your Name]`;

    // Encode subject and body for the URL
    const encodedSubject = encodeURIComponent(subject);
    const encodedBody = encodeURIComponent(body);

    const mailtoLink = `mailto:${recipient}?subject=${encodedSubject}&body=${encodedBody}`;
    window.location.href = mailtoLink;
  };

  return (
    <FooterContainer>
      <Link onClick={() => handleNavigate("privacy-policy")}>
        Privacy Policy
      </Link>
      <Link onClick={() => handleNavigate("terms-and-conditions")}>
        Terms of Use
      </Link>
      <Link onClick={handleEmailClick} title="Contact Support via Email">
        Support
      </Link>
    </FooterContainer>
  );
};

export default Footer;
